"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpResponse = void 0;
const http_headers_1 = require("./http-headers");
/**
 * An HTTP response.
 */
class HttpResponse {
    /**
     * Create a JSON HTTP response.
     *
     * @param parsedBody The parsed body of the response.
     * @param statusCode The status code. Default id 200.
     * @param headers Extra headers. The Content-Type headers are added automatically.
     */
    static json(parsedBody, statusCode = 200, headers = {}) {
        return {
            headers: [["content-type", "application/json"], ...(0, http_headers_1.normalizeHeaders)(headers)],
            statusCode,
            body: JSON.stringify(parsedBody),
            parsedBody,
        };
    }
    /**
     * Create a GraphQL response.
     *
     * @param response The GraphQL response.
     */
    static graphql(response) {
        const statusCode = response.errors ? 400 : 200;
        return this.json(response, statusCode);
    }
    /**
     * Returns the value of the first header matching by name (case-insensitive) or `undefined`.
     */
    static findHeaderValue(data, headerName) {
        const headers = Array.isArray(data) ? data : data.headers;
        for (const [name, value] of headers) {
            if (name.toLowerCase() === headerName.toLowerCase()) {
                return value;
            }
        }
        return undefined;
    }
    /**
     * The response headers.
     */
    headers;
    /**
     * The HTTP status code.
     */
    statusCode;
    /**
     * The Raw response body if available
     */
    body;
    /**
     * The Parsed response body (e.g. JSON) if available.
     */
    parsedBody;
    constructor(httpResponse) {
        this.headers = httpResponse.headers;
        this.statusCode = httpResponse.statusCode;
        if (httpResponse.body)
            this.body = httpResponse.body;
        if (httpResponse.parsedBody)
            this.parsedBody = httpResponse.parsedBody;
    }
}
exports.HttpResponse = HttpResponse;
//# sourceMappingURL=http-response.js.map